<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
  <path d="M4 23H20V21H4V23ZM20 11H16V1H8V11H4L12 19L20 11Z" />
</svg>
